// JsFromRoutes CacheKey eaf30ea5bca0e532aa3a2c1ce77c6f03
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  applyChanges: /* #__PURE__ */ definePathHelper('post', '/members/qualifying_life_events/:qualifying_life_event_id/apply_changes'),
  resume: /* #__PURE__ */ definePathHelper('get', '/members/qualifying_life_events/:qualifying_life_event_id/resume'),
  create: /* #__PURE__ */ definePathHelper('post', '/members/qualifying_life_events'),
  new: /* #__PURE__ */ definePathHelper('get', '/members/qualifying_life_events/new'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/members/qualifying_life_events/:id'),
}
